import { LABELS } from '@/constants/common/message.constants'

/**
 * 一覧検索の日付基準（VOC_PJ-939 #4387、設計 §4 D4）。
 * BE の SearchDateBasis enum（DEFAULT/INCOME_CLOSING_DATE/EXPENSE_CLOSING_DATE）と一致させる。
 *
 * - DEFAULT: 既存の暦日レンジ検索（発送日/着日/運行日）。省略時の既定。
 * - INCOME_CLOSING_DATE: 請求計上月の単月一致検索。荷主指定必須（§4 D8）。
 * - EXPENSE_CLOSING_DATE: 支払計上月の単月一致検索。運行実績一覧のみ。取引先指定は任意。
 */
export const SEARCH_DATE_BASIS = {
  DEFAULT: 'DEFAULT',
  INCOME_CLOSING_DATE: 'INCOME_CLOSING_DATE',
  EXPENSE_CLOSING_DATE: 'EXPENSE_CLOSING_DATE'
} as const

export type SearchDateBasis =
  (typeof SEARCH_DATE_BASIS)[keyof typeof SEARCH_DATE_BASIS]

/**
 * 配送依頼一覧が扱う検索基準（通常 / 請求月）。
 * 支払月は運行実績一覧のみが扱うため含めない。BE の DTO も同じ 2 値に限定している
 * （shipment-orders-list-search-option.dto.ts の SHIPMENT_ORDER_SEARCH_DATE_BASES）。
 */
export type IncomeSearchDateBasis =
  | typeof SEARCH_DATE_BASIS.DEFAULT
  | typeof SEARCH_DATE_BASIS.INCOME_CLOSING_DATE

export const SEARCH_DATE_BASIS_LABEL = {
  [SEARCH_DATE_BASIS.DEFAULT]: LABELS.SEARCH_BASIS_DEFAULT,
  [SEARCH_DATE_BASIS.INCOME_CLOSING_DATE]:
    LABELS.SEARCH_BASIS_INCOME_CLOSING_DATE,
  [SEARCH_DATE_BASIS.EXPENSE_CLOSING_DATE]:
    LABELS.SEARCH_BASIS_EXPENSE_CLOSING_DATE
} as const satisfies Record<SearchDateBasis, string>

/**
 * 締日基準モード（請求月 or 支払月）かどうか。
 * 締日基準モードでは計上月の単月一致を条件に加える。暦日レンジとは排他ではなく、
 * 両方が指定されていれば AND で絞り込まれる（Q-8 = 8-A、改訂 (10)）。
 */
export const isClosingDateBasis = (
  basis: SearchDateBasis | undefined
): boolean => basis !== undefined && basis !== SEARCH_DATE_BASIS.DEFAULT
